export default "__VITE_ASSET__ZpzESloW__"